import { ConsumptionFilterTypes } from '../interfaces/consumption.interface';

export const SOCIETIES_NAMES = {
  VANTI: 'vanti',
  GNCB: 'gncb',
  GOR: 'gor',
  GNCER: 'gncer',
};

export const ORIGIN_TYPES = {
  OR: '0R',
  '0M': '0M',
  '1C': '1C',
  '2C': '2C',
  '3C': '3C',
  '4C': '4C',
  '5C': '5C',
};

export const LOSS_TYPES = {
  PROJECTED: 'proyectada',
  REGULATORY: `regulatoria`,
};

export const LOSS_SOCIETIES = {
  VANTI: 'VANTI',
  GNCB: 'GNCB',
  GOR: 'GOR',
  BARRANCA: 'Barranca',
  GNCER: 'GNCER',
  METROGAS: 'Metrogas',
};

export const CONSUMPTION_FILTER_TYPES: ConsumptionFilterTypes = {
  sociedadCom: 'Sociedad Comercializadora',
  sociedadDis: 'Sociedad Distribuidora',
  mercadoVanti: 'Mercado VANTI',
  mercadoRel: 'Mercado Relevante',
  sistemaDis: 'Sistemas de distribución',
  CLIENTE: 'Cliente',
};
